export type LensAccessState = 'draft' | 'private' | 'public' | 'archived';

export function getLensAccessState(lens: {
  isPublished?: boolean;
  isArchived?: boolean;
  isPublic?: boolean;
}): LensAccessState {
  if (lens.isArchived) return 'archived';
  if (lens.isPublished === false) return 'draft';
  return lens.isPublic ? 'public' : 'private';
}
